/**
 * Custom Product Options - Complete Enhanced Functionality
 * Version 2.0 - Updated for button-based symbols
 */

(function () {
  "use strict";

  class CustomProductOptions {
    constructor() {
      this.config = {
        maxCharacters: window.engravingLimit, // Configurable max characters
      };

      this.symbolMap = {
        front: {},
        back: {},
      };
      this.symbolMapSingle = {};

      this.currentBasePrice = 0;

      this.init();
    }

    init() {
      if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", () => this.setup());
      } else {
        this.setup();
      }
    }

    setup() {
      console.log("🚀 Custom Product Options Initializing...");

      // Feature 1: Radio button unselect for Birthstone
      this.setupRadioUnselect();

      // Feature 2: Back side toggle functionality
      this.setupBackSideToggle();

      // Feature 2.5: Toggle Custom Size input visibility
      this.setupCustomSizeToggle();

      // Feature 3: Required validation with highlighting
      this.setupRequiredValidation();

      // Feature 4: Symbol buttons with image preview
      this.setupSymbolButtons();

      // Feature 4.1: Generic symbol-blocks (used by Charms, etc.)
      this.setupSymbolsBlocks();

      // Feature 4.2: Radio unselect for every [data-stone] block (e.g. per-charm birthstones)
      this.setupStoneUnselect();

      // Feature 4.3: Charms visibility controlled by "How many charms" variant option
      this.displayBirthstoneBar();

      this.isolatedPersonalisation();

      // Feature 4.5: Sync Engraving Side checkboxes with hidden option
      this.setupEngravingSideSync();

      // Feature 5: Selected swatch display for all inputs
      this.setupSelectedSwatchDisplay();

      // Feature 6: Hijack Add to Cart for specific template
      // this.setupAddToCartHijack();

      // Feature 7: Dynamic Price Update
      this.setupPriceObserver();

      console.log("✅ Custom Product Options Ready");
    }

    /**
     * Feature 1: Allow radio buttons to be unselected on second click
     */
    setupRadioUnselect() {
      const birthstoneContainer = document.querySelector('[data-option="Birthstone"]');
      if (!birthstoneContainer) return;
      const radioInputs = birthstoneContainer.querySelectorAll('input[type="radio"]');
      let lastSelected = null;

      radioInputs.forEach((radio) => {
        radio.addEventListener("click", (e) => {
          if (lastSelected === radio && radio.checked) {
            radio.checked = false;
            lastSelected = null;
            radio.dispatchEvent(new Event("change", { bubbles: true }));
            console.log("🔘 Birthstone unselected");
          } else {
            lastSelected = radio;
          }
        });
      });

      console.log("✅ Radio unselect enabled");
    }

    /**
     * Feature 2: Toggle Back Symbol and Back Engraving visibility
     */
    setupBackSideToggle() {
      const backSideCheckbox = document.querySelector('.shopify-product-form input[value="Front Side + Back Side"]');
      if (!backSideCheckbox) return;

      const backSymbolSection = document.querySelector('[data-option="Back engraving symbol"]');
      const backEngravingSection = document.querySelector('[data-option="Back engraving"]');

      const toggleBackSections = (show) => {
        if (show) {
          backSymbolSection?.classList.remove("hide");
          backEngravingSection?.classList.remove("hide");
        } else {
          backSymbolSection?.classList.add("hide");
          backEngravingSection?.classList.add("hide");
          const input = backEngravingSection.querySelector('input[name="properties[Back engraving]"]');
          if (input) {
            input.value = "";
            input.dispatchEvent(new Event("input", { bubbles: true }));
          }
        }
      };

      toggleBackSections(backSideCheckbox.checked);

      backSideCheckbox.addEventListener("change", (e) => {
        toggleBackSections(e.target.checked);
        this.updatePriceDisplay();
      });

      console.log("✅ Back side toggle enabled");
    }

    /**
     * Feature 2.5: Toggle Custom Size input visibility
     */
    setupCustomSizeToggle() {
      const sizeRadios = document.querySelectorAll('input[name="properties[Size]"]');
      if (!sizeRadios.length) return;

      const customSizeSection = document.querySelector('[data-option="Custom size"]');
      if (!customSizeSection) return;

      const toggleCustomSizeSection = (show) => {
        if (show) {
          customSizeSection.classList.remove("hide");
        } else {
          customSizeSection.classList.add("hide");
          const input = customSizeSection.querySelector('input[name="properties[Custom size]"]');
          if (input) {
            input.value = "";
            input.dispatchEvent(new Event("input", { bubbles: true }));
          }
        }
      };

      const updateVisibility = () => {
        const selectedRadio = document.querySelector('input[name="properties[Size]"]:checked');
        toggleCustomSizeSection(selectedRadio && selectedRadio.value === "Custom Size");
      };

      // Initial check
      updateVisibility();

      sizeRadios.forEach(radio => {
        radio.addEventListener("change", updateVisibility);
      });

      console.log("✅ Custom size toggle enabled");
    }

    /**
     * Feature 3: Required validation with button state
     */
    setupRequiredValidation() {
      const form_id = document.querySelector("div.shopify-product-form").dataset.form_id;
      const form = document.getElementById(form_id);
      if (!form) return;

      const submitButton = form.querySelector('button[type="submit"][name="add"]');
      if (!submitButton) return;
      submitButton.classList.add("required-fields");
      submitButton.addEventListener("click", function checkErrors(event) {
        event.preventDefault();
        event.stopPropagation();
        validateSubmit();
      });
      // submitButton.disabled = true;

      // Add required attributes
      // const requiredFields = [
      //   { selector: 'input[name="properties[Font]"]', type: "radio", label: "Font" },
      //   { selector: 'input[name="properties[Front engraving]"]', type: "text", label: "Front engraving" },
      //   { selector: 'input[name="properties[Size]"]', type: "radio", label: "Select Size" },
      //   { selector: 'input[name="properties[Birthstone]"]', type: "radio", label: "Birthstone" },
      //   { selector: 'input[name="properties[Back engraving]"]', type: "text", label: "Back engraving" },
      //   { selector: 'input[name="properties[Custom size]"]', type: "text", label: "Custom size" },
      // ];
      const requiredFields = [
        { selector: 'input[name="properties[Font]"]', type: "radio", label: "Font" },
        { selector: 'input[name="properties[Size]"]', type: "radio", label: "Select Size" },
        { selector: 'input[name="properties[Birthstone]"]', type: "radio", label: "Birthstone" },
        { selector: 'input[name="properties[Front engraving]"]', type: "text", label: "Front engraving" },
        { selector: 'input[name="properties[Back engraving]"]', type: "text", label: "Back engraving" },
        {
          selector: '[data-option="Personalization"][data-limit] input[name="properties[Personalization]"]',
          type: "text",
          label: "Personalization",
          when: () => !!document.querySelector('[data-option="Personalization"][data-limit]'),
        },
      ];

      // Charms are rendered per product option value, and blocks above the
      // "How many charms" selection are visually "blocked" — those inputs
      // must not participate in validation even though they stay in the DOM.
      const getDynamicCharmFields = () => {
        const out = [];
        const charmBlocks = document.querySelectorAll("[data-option='Charms'] .custom-options--block");
        charmBlocks.forEach((block) => {
          if (block.classList.contains("custom-options--block-blocked")) return;
          const idx = block.dataset.index;
          if (!idx) return;
          if (block.querySelector(`input[name="properties[Charm ${idx} engraving]"]`)) {
            out.push({
              selector: `input[name="properties[Charm ${idx} engraving]"]`,
              type: "text",
              label: `Charm ${idx} engraving`,
            });
          }
          if (block.querySelector(`input[name="properties[Birthstone Charm ${idx}]"]`)) {
            out.push({
              selector: `input[name="properties[Birthstone Charm ${idx}]"]`,
              type: "radio",
              label: `Birthstone Charm ${idx}`,
            });
          }
        });
        return out;
      };

      const getAllRequiredFields = () => [...requiredFields, ...getDynamicCharmFields()];

      const validate = () => {
        let allValid = true;
        // console.log("================")

        getAllRequiredFields().forEach((field) => {
          if (field.when && !field.when()) return;
          const inputs = document.querySelectorAll(field.selector);
          
          // If inputs are not present, skip validation (consider valid)
          if (inputs.length === 0) return;

          // Special check for Back engraving
          if (field.label === "Back engraving") {
            const backSideCheckbox = document.querySelector('input[type="checkbox"][value="Front Side + Back Side"]');
            if (!backSideCheckbox || !backSideCheckbox.checked) {
              return;
            }
          }

          // Special check for Custom size
          if (field.label === "Custom size") {
            const customSizeRadio = document.querySelector('input[type="radio"][name="properties[Size]"][value="Custom Size"]');
            if (!customSizeRadio || !customSizeRadio.checked) {
              return;
            }
          }

          let isValid = false;

          if (field.type === "radio") {
            isValid = Array.from(inputs).some((input) => input.checked);
          } else if (field.type === "text") {
            isValid = Array.from(inputs).every((input) => input.value.trim() !== "");
          }

          if (!isValid) {
            allValid = false;
            // console.log('🔥', field.label, isValid, allValid)
          }
        });
        setTimeout(() => {
          allValid && submitButton.classList.contains("required-fields") ? submitButton.classList.remove("required-fields") : submitButton.classList.add("required-fields");
        }, 50);
        // console.log('submitButton.disabled', !allValid)
      };

      const resolveErrorContainer = (fieldEl) => {
        if (!fieldEl) return null;
        return (
          fieldEl.closest(".custom-options__engraving-input") ||
          fieldEl.closest(".custom-options--stack") ||
          fieldEl.closest(".custom-options--block") ||
          fieldEl.closest(".custom-options--upload")
        );
      };

      const validateSubmit = () => {
        let allValid = true;

        getAllRequiredFields().forEach((field) => {
          if (field.when && !field.when()) return;
          const inputs = document.querySelectorAll(field.selector);

          // If inputs are not present, skip validation (consider valid)
          if (inputs.length === 0) return;

          // Special check for Back engraving
          if (field.label === "Back engraving") {
            const backSideCheckbox = document.querySelector('input[type="checkbox"][value="Front Side + Back Side"]');
            if (!backSideCheckbox || !backSideCheckbox.checked) {
              return;
            }
          }

          // Special check for Custom size
          if (field.label === "Custom size") {
            const customSizeRadio = document.querySelector('input[type="radio"][name="properties[Size]"][value="Custom Size"]');
            if (!customSizeRadio || !customSizeRadio.checked) {
              return;
            }
          }

          let isValid = false;

          if (field.type === "radio") {
            isValid = Array.from(inputs).some((input) => input.checked);
          } else if (field.type === "text") {
            isValid = Array.from(inputs).every((input) => input.value.trim() !== "");
          }
          const container = resolveErrorContainer(inputs[0]);

          if (!isValid) {
            allValid = false;
            if (container) container.classList.add("error");
          } else if (container) {
            container.classList.remove("error");
          }
        });

        const headerHeight = 70;
        if (!allValid) {
          const firstError = document.querySelector(
            ".custom-options--stack.error, .custom-options__engraving-input.error, .custom-options--block.error",
          );
          if (firstError) {
            const elementPosition = firstError.getBoundingClientRect().top + window.scrollY;
            window.scrollTo({ top: elementPosition - headerHeight, behavior: "smooth" });
          }
        }

        setTimeout(() => {
          if (allValid) {
            submitButton.classList.remove("required-fields");
            if (typeof form.requestSubmit === "function") {
              form.requestSubmit(submitButton);
            } else {
              form.submit();
            }
          } else {
            submitButton.classList.add("required-fields");
          }
        }, 50);
      };

      // Build the initial list of all fields (static + charm fields that
      // currently exist in the DOM, regardless of blocked state) so we can
      // attach listeners once. Unblocking a charm block later does not
      // re-create inputs — they're just toggled visually — so this is safe.
      const getAllCharmFieldsForInit = () => {
        const out = [];
        const charmBlocks = document.querySelectorAll("[data-option='Charms'] .custom-options--block");
        charmBlocks.forEach((block) => {
          const idx = block.dataset.index;
          if (!idx) return;
          if (block.querySelector(`input[name="properties[Charm ${idx} engraving]"]`)) {
            out.push({ selector: `input[name="properties[Charm ${idx} engraving]"]`, type: "text" });
          }
          if (block.querySelector(`input[name="properties[Birthstone Charm ${idx}]"]`)) {
            out.push({ selector: `input[name="properties[Birthstone Charm ${idx}]"]`, type: "radio" });
          }
        });
        return out;
      };

      // Attach listeners
      [...requiredFields, ...getAllCharmFieldsForInit()].forEach((field) => {
        if (field.when && !field.when()) return;
        const inputs = document.querySelectorAll(field.selector);
        inputs.forEach((input) => {
           if (field.type === "radio") {
            input.addEventListener("change", function(e){
              const container = input.closest(".custom-options--stack.error");
              container ? container.classList.remove("error") : null;
              
          });
          } else if (field.type === "text") {
           input.addEventListener("input", function(e){
            const container = input.closest(".custom-options--stack.error");
              container ? container.classList.remove("error") : null;
          });
          }
          

        });
      });

      // Listen to back side checkbox change
      const backSideCheckbox = document.querySelector('input[type="checkbox"][value="Front Side + Back Side"]');
      // if (backSideCheckbox) {
      //   backSideCheckbox.addEventListener("change", validateSubmit);
      // }
    }

    /**
     * Feature 4: Symbol buttons with preview
     */
    setupSymbolButtons() {
      this.setupSymbolsForSide("Front engraving symbol", "Front engraving", "front");
      this.setupSymbolsForSide("Back engraving symbol", "Back engraving", "back");
    }

    setupSymbolsForSide(symbolOptionName, engravingOptionName, side) {
      const symbolSection = document.querySelector(`[data-option="${symbolOptionName}"]`);
      const engravingSection = document.querySelector(`[data-option="${engravingOptionName}"]`);
      const engravingInput = document.querySelector(`input[name="properties[${engravingOptionName}]"]`);

      if (!engravingInput || !engravingSection) return;

      // Create preview element after the input
      let previewElement = engravingSection.querySelector(".engraving-preview");
      if (!previewElement) {
        previewElement = document.createElement("div");
        previewElement.className = "engraving-preview";
        previewElement.style.cssText = `
          margin-top: 12px;
          padding: 12px;
          background: #f8f8f8;
          border: 1px solid #e0e0e0;
          border-radius: 6px;
          min-height: 50px;
          display: flex;
          align-items: center;
          gap: 6px;
          flex-wrap: wrap;
          font-size: 16px;
          line-height: 1.5;
        `;

        const inputContainer = engravingSection.querySelector(".custom-options--option--container");
        inputContainer.after(previewElement);
      }

      // Create character counter in help text
      let helpText = engravingSection.querySelector(".custom-options--helptext-content");
      if (!helpText) {
        helpText = document.createElement("div");
        helpText.className = "custom-options--helptext-content";
        engravingSection.appendChild(helpText);
      }

      const updateCharacterCount = () => {
        const count = this.getCharacterCount(side);
        helpText.innerHTML = `<p>${count}/${this.config.maxCharacters}</p>`;

        if (count >= this.config.maxCharacters) {
          helpText.style.color = "#d32f2f";
        } else {
          helpText.style.color = "";
        }
      };

      // Get all symbol buttons (section omitted when symbols hidden in theme — still enforce limit + counter)
      const symbolButtons = symbolSection ? symbolSection.querySelectorAll("button[data-target]") : [];

      // Populate symbol map
      symbolButtons.forEach((button, index) => {
        const symbolImage = button.querySelector(".custom-options--option__image-value");
        const symbolName = button.querySelector(".co_option_value")?.textContent || `symbol-${index + 1}`;
        const imageUrl = symbolImage?.style.backgroundImage.match(/url\("?(.+?)"?\)/)?.[1];
        if (symbolName && imageUrl) {
          this.symbolMap[side][symbolName] = imageUrl;
        }
      });

      let lastValue = engravingInput.value;

      // Handle symbol button clicks
      symbolButtons.forEach((button, index) => {
        button.addEventListener("click", (e) => {
          e.preventDefault();

          const symbolName = button.querySelector(".co_option_value")?.textContent || `symbol-${index + 1}`;
         
          if (!this.symbolMap[side][symbolName]) return;

          // Get current cursor position
          const cursorPos = engravingInput.selectionStart || engravingInput.value.length;
          const currentValue = engravingInput.value;

          // Check character limit
          if (this.getCharacterCount(side) >= this.config.maxCharacters) {
            alert(`Maximum ${this.config.maxCharacters} characters reached`);
            return;
          }

          // Insert symbol tag at cursor position
          const symbolTag = `[${symbolName}]`;
          const before = currentValue.substring(0, cursorPos);
          const after = currentValue.substring(cursorPos);
          engravingInput.value = before + symbolTag + after;
          engravingInput.dispatchEvent(new Event("input", { bubbles: true }));

          // Update preview
          this.updatePreview(side, engravingInput, previewElement);
          updateCharacterCount();

          // Set cursor after symbol
          engravingInput.selectionStart = engravingInput.selectionEnd = cursorPos + symbolTag.length;
          engravingInput.focus();

          // console.log(`✨ Symbol added: ${symbolName}`);
        });
      });

      // Handle text input changes
      engravingInput.addEventListener("input", (e) => {
        const currentCount = this.getCharacterCount(side, engravingInput.value);
        const previousCount = this.getCharacterCount(side, lastValue);

        if (currentCount > this.config.maxCharacters && currentCount > previousCount) {
          engravingInput.value = lastValue;
        } else {
          lastValue = engravingInput.value;
        }

        this.updatePreview(side, engravingInput, previewElement);
        updateCharacterCount();
      });

      // Handle backspace to remove symbols
      engravingInput.addEventListener("keydown", (e) => {
        if (e.key === "Backspace") {
          const cursorPos = engravingInput.selectionStart;
          const currentValue = engravingInput.value;

          if (cursorPos > 0) {
            const beforeCursor = currentValue.substring(0, cursorPos);
            // Check if we are deleting the closing bracket of a symbol
            const match = beforeCursor.match(/\[([^\]]+)\]$/);

            if (match) {
              const symbolName = match[1];
              if (this.symbolMap[side][symbolName]) {
                e.preventDefault();
                // Remove the whole tag
                const newValue = currentValue.substring(0, cursorPos - match[0].length) + currentValue.substring(cursorPos);
                engravingInput.value = newValue;
                engravingInput.selectionStart = engravingInput.selectionEnd = cursorPos - match[0].length;
                engravingInput.dispatchEvent(new Event("input", { bubbles: true }));

                this.updatePreview(side, engravingInput, previewElement);
                updateCharacterCount();
              }
            }
          }
        }
      });

      // Initial update
      updateCharacterCount();

      console.log(`✅ Engraving ${symbolSection ? "+ symbols" : "(limit + counter only)"} for ${side}`);
    }

    /**
     * Character count for standalone Personalization line item (no side / symbol map).
     * Each [tag] counts as one grapheme; emoji handled like getCharacterCount.
     */
    getCharacterQuantity(input, value = null) {
      if (!input) return 0;

      let text = value !== null ? value : input.value;
      text = text.trimEnd();
      text = text.replace(/\[([^\]]+)\]/g, "1");

      const segmenter = new Intl.Segmenter("uk", { granularity: "grapheme" });
      const segments = Array.from(segmenter.segment(text));
      const emojiRegex = /\p{Extended_Pictographic}/u;

      let emojiCount = 0;
      let charCount = 0;
      for (const { segment } of segments) {
        if (emojiRegex.test(segment)) {
          emojiCount++;
        } else if (segment.trim().length > 0) {
          charCount++;
        }
      }
      return emojiCount + charCount;
    }

    isolatedPersonalisation() {
      const personalisationBlock = document.querySelector("[data-option='Personalization'][data-limit]");
      const personalisationInput = personalisationBlock?.querySelector("#personalization_input");
      if (!personalisationBlock || !personalisationInput) return;

      const maxValue = parseInt(personalisationBlock.getAttribute("data-limit"), 10) || 15;
      const currentValueContainer = personalisationBlock.querySelector(".personalization-counter--current");
      let lastValue = personalisationInput.value;

      const syncCounter = () => {
        if (currentValueContainer) {
          currentValueContainer.textContent = String(this.getCharacterQuantity(personalisationInput));
        }
      };

      syncCounter();

      personalisationInput.addEventListener("input", () => {
        const currentCount = this.getCharacterQuantity(personalisationInput, personalisationInput.value);
        const previousCount = this.getCharacterQuantity(personalisationInput, lastValue);
        if (currentCount > maxValue && currentCount > previousCount) {
          personalisationInput.value = lastValue;
          syncCounter();
        } else {
          lastValue = personalisationInput.value;
          syncCounter();
        }
      });
    }

    updatePreview(side, input, previewElement) {
      const value = input.value.trimEnd(); // Trim trailing spaces
      previewElement.innerHTML = "";

      if (!value) {
        previewElement.style.display = "none";
        return;
      }

      previewElement.style.display = "flex";

      // Split by symbol tags
      const parts = value.split(/(\[[^\]]+\])/);

      let previewHTML = "";
      parts.forEach((part) => {
        const match = part.match(/^\[([^\]]+)\]$/);
        if (match && this.symbolMap[side][match[1]]) {
          const symbolName = match[1];
          const imageUrl = this.symbolMap[side][symbolName];
          previewHTML += `<img src="${imageUrl}" alt="${symbolName}" style="width: 24px; height: 24px; object-fit: contain; margin: 0 2px;">`;
        } else if (part) {
          previewHTML += `<span>${part}</span>`;
        }
      });

      previewElement.innerHTML = previewHTML;
    }

    /**
     * Generic symbol-block handler — runs for any [data-symbol] section,
     * such as Charm N Symbol + Charm N engraving pairs.
     * Mirrors the logic of setupSymbolsForSide() but scoped per-block using
     * the shared symbolMapSingle so multiple blocks don't collide.
     */
    setupSymbolsBlocks() {
      const symbolSections = document.querySelectorAll('[data-symbol]');
      symbolSections.forEach((symbolSection) => {
        const symbolMaxCount = parseInt(symbolSection.getAttribute("data-symbol")) || 10;
        const engravingSection = symbolSection.querySelector('[data-option]');
        const engravingInput = symbolSection.querySelector('input');

        if (!symbolSection || !engravingInput || !engravingSection) return;

        let previewElement = engravingSection.querySelector(".engraving-preview");
        if (!previewElement) {
          previewElement = document.createElement("div");
          previewElement.className = "engraving-preview";
          previewElement.style.cssText = `
            margin-top: 12px;
            padding: 12px;
            background: #f8f8f8;
            border: 1px solid #e0e0e0;
            border-radius: 6px;
            min-height: 50px;
            display: flex;
            align-items: center;
            gap: 6px;
            flex-wrap: wrap;
            font-size: 16px;
            line-height: 1.5;
          `;

          const inputContainer = symbolSection.querySelector(".custom-options__engraving-input");
          if (inputContainer) inputContainer.after(previewElement);
        }

        let helpText = symbolSection.querySelector(".custom-options--helptext-content");
        if (!helpText) {
          helpText = document.createElement("div");
          helpText.className = "custom-options--helptext-content";
          symbolSection.appendChild(helpText);
        }

        const updateCharacterCount = () => {
          const count = this.getCharacterCountSingle(engravingInput);
          helpText.innerHTML = `<p>${count}/${symbolMaxCount}</p>`;
          helpText.style.color = count >= symbolMaxCount ? "#d32f2f" : "";
        };

        const symbolButtons = symbolSection.querySelectorAll("button[data-target]");

        symbolButtons.forEach((button, index) => {
          const symbolImage = button.querySelector(".custom-options--option__image-value");
          const symbolName = button.querySelector(".co_option_value")?.textContent || `symbol-${index + 1}`;
          const imageUrl = symbolImage?.style.backgroundImage.match(/url\("?(.+?)"?\)/)?.[1];
          if (symbolName && imageUrl) {
            this.symbolMapSingle[symbolName] = imageUrl;
          }
        });

        let lastValue = engravingInput.value;

        symbolButtons.forEach((button, index) => {
          button.addEventListener("click", (e) => {
            e.preventDefault();
            const symbolName = button.querySelector(".co_option_value")?.textContent || `symbol-${index + 1}`;
            if (!this.symbolMapSingle[symbolName]) return;

            const cursorPos = engravingInput.selectionStart || engravingInput.value.length;
            const currentValue = engravingInput.value;

            if (this.getCharacterCountSingle(engravingInput) >= symbolMaxCount) {
              alert(`Maximum ${symbolMaxCount} characters reached`);
              return;
            }

            const symbolTag = `[${symbolName}]`;
            const before = currentValue.substring(0, cursorPos);
            const after = currentValue.substring(cursorPos);
            engravingInput.value = before + symbolTag + after;
            engravingInput.dispatchEvent(new Event("input", { bubbles: true }));

            this.updatePreviewSingle(engravingInput, previewElement);
            updateCharacterCount();

            engravingInput.selectionStart = engravingInput.selectionEnd = cursorPos + symbolTag.length;
            engravingInput.focus();
          });
        });

        engravingInput.addEventListener("input", () => {
          const currentCount = this.getCharacterCountSingle(engravingInput, engravingInput.value);
          const previousCount = this.getCharacterCountSingle(engravingInput, lastValue);

          if (currentCount > symbolMaxCount && currentCount > previousCount) {
            engravingInput.value = lastValue;
          } else {
            lastValue = engravingInput.value;
          }

          this.updatePreviewSingle(engravingInput, previewElement);
          updateCharacterCount();
        });

        engravingInput.addEventListener("keydown", (e) => {
          if (e.key !== "Backspace") return;
          const cursorPos = engravingInput.selectionStart;
          const currentValue = engravingInput.value;
          if (cursorPos <= 0) return;

          const beforeCursor = currentValue.substring(0, cursorPos);
          const match = beforeCursor.match(/\[([^\]]+)\]$/);
          if (!match) return;

          const symbolName = match[1];
          if (!this.symbolMapSingle[symbolName]) return;

          e.preventDefault();
          const newValue = currentValue.substring(0, cursorPos - match[0].length) + currentValue.substring(cursorPos);
          engravingInput.value = newValue;
          engravingInput.selectionStart = engravingInput.selectionEnd = cursorPos - match[0].length;
          engravingInput.dispatchEvent(new Event("input", { bubbles: true }));

          this.updatePreviewSingle(engravingInput, previewElement);
          updateCharacterCount();
        });

        updateCharacterCount();
      });

      console.log("✅ Symbol blocks enabled");
    }

    /**
     * Radio-unselect handler for every [data-stone] container (per-charm
     * birthstones, etc.) — each container keeps its own lastSelected pointer
     * so clicks don't cross-unselect.
     */
    setupStoneUnselect() {
      const stoneContainers = document.querySelectorAll("[data-stone]");
      if (!stoneContainers.length) return;

      stoneContainers.forEach((stoneContainer) => {
        const radioInputs = stoneContainer.querySelectorAll('input[type="radio"]');
        if (!radioInputs.length) return;

        let lastSelected = null;
        radioInputs.forEach((radio) => {
          radio.addEventListener("click", () => {
            if (lastSelected === radio && radio.checked) {
              radio.checked = false;
              lastSelected = null;
              radio.dispatchEvent(new Event("change", { bubbles: true }));
            } else {
              lastSelected = radio;
            }
          });
        });
      });

      console.log("✅ Radio unselect enabled for all [data-stone] blocks");
    }

    /**
     * Controls visibility of charm blocks based on the "How many charms"
     * variant option. Blocks above the chosen count are "blocked" (grayed).
     */
    displayBirthstoneBar() {
      const charms = document.querySelector(".option-how-many-charms");
      if (!charms) return;

      const charmBlocks = document.querySelectorAll("[data-option='Charms'] .custom-options--block");
      if (!charmBlocks.length) return;

      const applyState = (selectedValue) => {
        charmBlocks.forEach((charmBlock, index) => {
          if (index + 1 <= selectedValue) {
            charmBlock.classList.remove("custom-options--block-blocked");
          } else {
            charmBlock.classList.add("custom-options--block-blocked");
          }
        });
      };

      const initialChecked = charms.querySelector("input:checked");
      if (initialChecked) applyState(parseInt(initialChecked.value));

      charms.addEventListener("click", (e) => {
        const input = e.target.closest("input");
        if (!input) return;
        applyState(parseInt(input.value));
      });
    }

    /**
     * Character counter used by setupSymbolsBlocks — mirrors getCharacterCount
     * but scoped to any input via the shared symbolMapSingle.
     */
    getCharacterCountSingle(inputItem, value = null) {
      const input = inputItem;
      if (!input) return 0;

      let text = value !== null ? value : input.value;
      text = text.trimEnd();
      // Будь-який тег [name] = один символ для ліміту (навіть якщо кнопки символів сховані)
      text = text.replace(/\[([^\]]+)\]/g, "1");

      const segmenter = new Intl.Segmenter('uk', { granularity: 'grapheme' });
      const segments = Array.from(segmenter.segment(text));

      let emojiCount = 0;
      let charCount = 0;
      const emojiRegex = /\p{Extended_Pictographic}/u;

      for (const { segment } of segments) {
        if (emojiRegex.test(segment)) {
          emojiCount++;
        } else if (segment.trim().length > 0) {
          charCount++;
        }
      }

      return emojiCount + charCount;
    }

    /**
     * Preview builder for single-symbol blocks (Charms, etc.).
     */
    updatePreviewSingle(input, previewElement) {
      const value = input.value.trimEnd();
      previewElement.innerHTML = "";

      if (!value) {
        previewElement.style.display = "none";
        return;
      }

      previewElement.style.display = "flex";

      const parts = value.split(/(\[[^\]]+\])/);
      let previewHTML = "";
      parts.forEach((part) => {
        const match = part.match(/^\[([^\]]+)\]$/);
        if (match && this.symbolMapSingle[match[1]]) {
          const symbolName = match[1];
          const imageUrl = this.symbolMapSingle[symbolName];
          previewHTML += `<img src="${imageUrl}" alt="${symbolName}" style="width: 24px; height: 24px; object-fit: contain; margin: 0 2px;">`;
        } else if (part) {
          previewHTML += `<span>${part}</span>`;
        }
      });

      previewElement.innerHTML = previewHTML;
    }

    getCharacterCount(side, value = null) {
      const input = document.querySelector(
        side === "front" ? 'input[name="properties[Front engraving]"]' : 'input[name="properties[Back engraving]"]',
      );

      if (!input) return 0;

      let text = value !== null ? value : input.value;
      text = text.trimEnd();
      text = text.replace(/\[([^\]]+)\]/g, "1");

      const segmenter = new Intl.Segmenter("uk", { granularity: "grapheme" });
      const segments = Array.from(segmenter.segment(text));

      let emojiCount = 0;
      let charCount = 0;
      const emojiRegex = /\p{Extended_Pictographic}/u;

      for (const { segment } of segments) {
        if (emojiRegex.test(segment)) {
          emojiCount++;
        } else if (segment.trim().length > 0) {
          charCount++;
        }
      }

      return emojiCount + charCount;
    }

    /**
     * Feature 4.5: Sync Engraving Side checkboxes with hidden option
     */
    setupEngravingSideSync() {
      const backSideCheckbox = document.querySelector('.shopify-product-form input[value="Front Side + Back Side"]');
      if (!backSideCheckbox) return;

      // Try to find the hidden option selector (Radio or Select)
      const form_id = document.querySelector("div.shopify-product-form").dataset.form_id;
      const form = document.getElementById(form_id);
      if (!form) return;

      // Look for radio
      const radioBack = document.querySelector(`input[type="radio"][value="Front Side + Back Side"]`);
      const radioFront = document.querySelector(`input[type="radio"][value="Front Side"]`);

      // console.log("radioBack", radioBack);
      // console.log("radioFront", radioFront);

      const syncOption = (isChecked) => {
        if (radioBack && radioFront) {
          const target = isChecked ? radioBack : radioFront;
          target.checked = true;
          target.dispatchEvent(new Event("change", { bubbles: true }));
          target.click();
        }
      };

      // Initial sync if checked
      if (backSideCheckbox.checked) syncOption(true);

      backSideCheckbox.addEventListener("change", (e) => {
        syncOption(e.target.checked);
      });
    }

    /**
     * Feature 5: Selected swatch display without changing height
     */
    setupSelectedSwatchDisplay() {
      // Setup for Birthstone
      this.setupDisplayForOption("Birthstone", "radio");

      // Setup for Font
      this.setupDisplayForOption("Font", "radio");

      // Setup for Size
      this.setupDisplayForOption("Size", "radio");

      // Setup for Engraving Side
      this.updateEngravingSideDisplay();

      // Add CSS to prevent height changes
      this.addSwatchDisplayCSS();
    }

    setupDisplayForOption(optionName, inputType) {
      const optionSection = document.querySelector(`[data-option="${optionName}"]`);
      if (!optionSection) return;

      const labelContainer = optionSection.querySelector(".custom-options--label-container");
      if (!labelContainer) return;

      let selectedDisplay = labelContainer.querySelector(".custom-options--selected-swatch");
      if (!selectedDisplay) {
        selectedDisplay = document.createElement("div");
        selectedDisplay.className = "custom-options--selected-swatch";
        selectedDisplay.style.opacity = "0";
        selectedDisplay.style.height = "0";
        selectedDisplay.style.overflow = "hidden";
        selectedDisplay.style.transition = "opacity 0.2s ease, height 0.2s ease";
        labelContainer.appendChild(selectedDisplay);
      }

      const updateDisplay = () => {
        let selectedValue = "";

        if (inputType === "radio") {
          const checked = optionSection.querySelector(`input[name="properties[${optionName}]"]:checked`);
          if (checked) {
            const label = checked.closest("label");
            const valueSpan = label?.querySelector(".co_option_value");
            selectedValue = valueSpan ? valueSpan.innerHTML : checked.value;
          }
        }

        if (selectedValue) {
          selectedDisplay.innerHTML = `<p class="swatch_value custom-options--value">${selectedValue}</p>`;
          selectedDisplay.style.opacity = "1";
          selectedDisplay.style.height = "auto";
          selectedDisplay.style.marginTop = "8px";
        } else {
          selectedDisplay.style.opacity = "0";
          selectedDisplay.style.height = "0";
          selectedDisplay.style.marginTop = "0";
        }
      };

      const inputs = optionSection.querySelectorAll(`input[name="properties[${optionName}]"]`);
      inputs.forEach((input) => {
        input.addEventListener("change", updateDisplay);
      });

      updateDisplay();
    }

    updateEngravingSideDisplay() {
      const engravingSideSection = document.querySelector('[data-option="Engraving side"]');
      if (!engravingSideSection) return;

      const frontCheckbox = engravingSideSection.querySelector('input[value="Front Side"]');
      const backCheckbox = engravingSideSection.querySelector('input[value="Front Side + Back Side"]');
      const selectedDisplay = engravingSideSection.querySelector(".custom-options--selected-swatch");

      if (!selectedDisplay) return;

      const updateDisplay = () => {
        let displayText = "";

        if ((frontCheckbox && frontCheckbox.checked) && (backCheckbox && backCheckbox.checked)) {
          displayText = "Front Side<span>(Most Popular)</span> + Back Side<span>(Optional)</span>";
        } else if (frontCheckbox && frontCheckbox.checked) {
          displayText = "Front Side<span>(Most Popular)</span>";
        } else if (backCheckbox && backCheckbox.checked) {
          displayText = "Back Side<span>(Optional)</span>";
        }

        selectedDisplay.innerHTML = `<p class="swatch_value custom-options--value">${displayText}</p>`;
      };

      frontCheckbox ? frontCheckbox.addEventListener("change", updateDisplay) : null;
      backCheckbox ? backCheckbox.addEventListener("change", updateDisplay) : null;

      updateDisplay();
    }

    addSwatchDisplayCSS() {
      const style = document.createElement("style");
      style.textContent = `
        .custom-options--selected-swatch {
          transition: opacity 0.2s ease, height 0.2s ease, margin 0.2s ease;
        }
        
        .custom-options--selected-swatch p {
          margin: 0;
          padding: 6px 10px;
          background: #f5f5f5;
          border-radius: 4px;
          font-size: 13px;
          color: #666;
        }

        .custom-options--selected-swatch span {
          font-size: 11px;
          color: #999;
          margin-left: 4px;
        }

        .engraving-preview {
          animation: fadeIn 0.2s ease;
        }

        @keyframes fadeIn {
          from { opacity: 0; transform: translateY(-5px); }
          to { opacity: 1; transform: translateY(0); }
        }

        .hide {
          display: none !important;
        }

        /* Symbol button active state */
        button.custom-options--option__value:active {
          transform: scale(0.95);
        }

        button.custom-options--option__value:hover {
          opacity: 0.8;
        }
      `;
      document.head.appendChild(style);
    }

    /**
     * Feature 6: Hijack Add to Cart event
     */
    setupAddToCartHijack() {
      // TODO: Replace 'your-template-class' with the actual class on the <body> tag
      if (!document.body.classList.contains("product-custom-options")) return;

      const form_id = document.querySelector("div.shopify-product-form")?.dataset.form_id;
      const form = document.getElementById(form_id);
      if (!form) return;

      const submitButton = form.querySelector('button[type="submit"][name="add"]');
      if (!submitButton) return;

      submitButton.addEventListener("click", async (e) => {
        // Prevent default form submission and theme scripts
        e.preventDefault();
        e.stopImmediatePropagation();

        console.log("🛑 Add to Cart event hijacked");

        const formData = new FormData(form);

        // Handle Engraving Side logic
        const engravingKey = "properties[Engraving side][]";
        const engravingValues = formData.getAll(engravingKey);
        const hasFront = engravingValues.includes("Front Side");
        const hasBack = engravingValues.includes("Front Side + Back Side");

        let bundleId = null;
        if (hasBack) {
          bundleId = `bundle_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
        }

        // 1. Prepare Main Item
        const mainItem = {
          id: formData.get("id"),
          quantity: 1,
          properties: {},
        };

        if (bundleId) {
          mainItem.properties["_bundleId"] = bundleId;
        }

        // Extract properties from form data
        for (const [key, value] of formData.entries()) {
          if (key === engravingKey) continue; // Skip, handled manually

          if (key.startsWith("properties[") && key.endsWith("]")) {
            const propName = key.substring(11, key.length - 1);
            if (value && value.trim() !== "") {
              mainItem.properties[propName] = value;
            }
          }
        }

        // Construct Engraving side string
        if (hasFront || hasBack) {
          let engravingString = hasFront ? "Front Side" : "";
          let priceString = "";

          if (hasBack) {
            if (window.addOnProduct && window.addOnProduct.variants) {
              const variant = window.addOnProduct.variants.find((v) => v.available) || window.addOnProduct.variants[0];
              if (variant) {
                priceString = ` (+ $${(variant.price / 100).toFixed(2)})`;
              }
            }
            engravingString += (hasFront ? " + " : "") + "Back Side" + priceString;
          }

          mainItem.properties["Engraving side"] = engravingString;
        }

        const items = [mainItem];

        // 2. Prepare Add-on Item (Only if Back Side is selected)
        if (hasBack && window.addOnProduct && window.addOnProduct.variants) {
          const firstAvailable = window.addOnProduct.variants.find((v) => v.available);
          if (firstAvailable) {
            items.push({
              id: firstAvailable.id,
              quantity: 1,
              properties: {
                _bundleId: bundleId,
              },
            });
          } else {
            console.warn("Add-on product has no available variants.");
          }
        }

        // 3. Send to Cart API
        try {
          submitButton.classList.add("btn--loading");

          const response = await fetch("/cart/add.js", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({ items }),
          });

          const data = await response.json();

          if (response.ok) {
            console.log("✅ Items added to cart:", data);
            // window.location.href = "/cart";
            document.dispatchEvent(new CustomEvent("ajaxProduct:added"));
            submitButton.classList.remove("btn--loading");
          } else {
            console.error("❌ Error adding to cart:", data);
            alert(data.description || "Error adding to cart");
            submitButton.classList.remove("btn--loading");
          }
        } catch (error) {
          console.error("❌ Network error:", error);
          submitButton.classList.remove("btn--loading");
        }
      });

      console.log("✅ Add to Cart Hijack enabled");
    }

    /**
     * Feature 7: Price Observer
     */
    setupPriceObserver() {
      // 1. Get initial variant price
      if (window.product && window.product.variants) {
        let variantId = null;

        // Try form input first
        const form_id = document.querySelector("div.shopify-product-form")?.dataset.form_id;
        const form = document.getElementById(form_id);
        const idInput = form?.querySelector('[name="id"]');
        if (idInput) {
          variantId = idInput.value;
        }

        let variant;
        if (variantId) {
          variant = window.product.variants.find((v) => v.id == variantId);
        }

        if (!variant) {
          variant = window.product.variants.find((v) => v.available) || window.product.variants[0];
        }

        if (variant) {
          this.currentBasePrice = variant.price;
        }
      }

      // 2. Listen for variant changes (Impulse theme event)
      document.addEventListener("variant:change", (e) => {
        if (e.detail.variant) {
          this.currentBasePrice = e.detail.variant.price;

          // Sync checkbox state if variant options dictate it
          const variant = e.detail.variant;
          const backSideCheckbox = document.querySelector('.shopify-product-form input[value="Front Side + Back Side"]');

          if (backSideCheckbox) {
            if (variant.options.includes("Front Side")) {
              if (backSideCheckbox.checked) {
                backSideCheckbox.checked = false;
                backSideCheckbox.dispatchEvent(new Event("change"));
              }
            } else if (variant.options.includes("Front Side + Back Side")) {
              if (!backSideCheckbox.checked) {
                backSideCheckbox.checked = true;
                backSideCheckbox.dispatchEvent(new Event("change"));
              }
            }
          }

          // Delay to ensure we override theme.js default price update
          setTimeout(() => {
            this.updatePriceDisplay();
          }, 50);
        }
      });

      // Initial update
      this.updatePriceDisplay();
    }

    updatePriceDisplay() {
      // const backSideCheckbox = document.querySelector('.shopify-product-form input[value="Front Side + Back Side"]');
      let finalPrice = this.currentBasePrice;

      // if (backSideCheckbox && backSideCheckbox.checked && window.addOnProduct) {
      //   const addOnVariant = window.addOnProduct.variants.find((v) => v.available) || window.addOnProduct.variants[0];
      //   if (addOnVariant) {
      //     finalPrice += addOnVariant.price;
      //   }
      // }

      const priceElements = document.querySelectorAll(
        ".price__regular .price-item--regular, .product__price:not(.product__price--compare), .price-item--regular",
      );

      if (window.theme && window.theme.Currency && window.theme.settings) {
        const formattedPrice = theme.Currency.formatMoney(finalPrice, theme.settings.moneyFormat);
        priceElements.forEach((el) => (el.innerHTML = formattedPrice));
      }
    }
  }

  // Initialize
  new CustomProductOptions();
})();
